import {gql} from 'graphql-tag'
import { fragmentModuleMedia } from '../../../core/data-layer/modules/fragments'

export default gql`
  ${fragmentModuleMedia}
  fragment BlockManualContentFragment on BlockManualContent {
    title
    contentBlock1Text {
      json
    }
    contentBlock1Media {
      ...ModuleMediaFragment
    }
    contentBlock2Text {
      json
    }
    contentBlock2Media {
      ...ModuleMediaFragment
    }
  }
`
